export class Pagination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recordsCount",
            "baseName": "recordsCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "queryExecutionId",
            "baseName": "queryExecutionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Pagination.attributeTypeMap;
    }
    constructor() {
    }
}
